<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#173EA3"
      :is-full-page="fullPage"
    ></loading>
    <div class="col-12">
      <div class="card">
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
        <Toast />

          <div class="grid p-fluid mt-3" style="margin-top: 2%;">

            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <InputText v-model="event_name"
                onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || 
                      (event.charCode >= 97 && event.charCode <= 122) || 
                      event.charCode == 32"
                > </InputText>
                <label>Event Name</label>
              </span>
            </div>

            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <InputText v-model="event_city"
                onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || 
                      (event.charCode >= 97 && event.charCode <= 122) || 
                      event.charCode == 32"
                > </InputText>
                <label>City</label>
              </span>
            </div>

            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <Calendar
                  v-model="event_from_date"
                  dateFormat="dd-mm-yy"
                  :showIcon="true"
                  :showTime="false"
                  hourFormat="12"
                />
                <label>From Date</label>
              </span>
            </div>

            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <Calendar
                  v-model="event_to_date"
                  dateFormat="dd-mm-yy"
                  :showIcon="true"
                  :showTime="false"
                  hourFormat="12"
                />
                <label>To Date</label>
              </span>
            </div>

            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <Dropdown
                  id="status"
                  v-model="event_status"
                  :options="dropdownItems"
                  :value="dropdownItems.value"
                  optionLabel="name"
                ></Dropdown>
                <label>Status</label>
              </span>
            </div>

            <div class="field col-12 md:col-2">
              <Button
                icon="pi pi-search"
                class="p-button-sm"
                v-tooltip.bottom="'Search'"
                @click="search(1)"
              />&nbsp;
              <Button   class="p-button-danger p-button-sm"  icon="pi pi-refresh" @click="reset()" v-tooltip.bottom="'Reset'" />
            </div>

          </div>
          <!-- </template> -->
          <!-- <template v-slot:end> -->
            <!-- &nbsp;
            <json-excel :data="product">
              <Button
                icon="pi pi-upload"
                v-tooltip.bottom="'export'"
                @click="exportCSV"
              />
            </json-excel> -->
        <!-- {{products}} -->
        <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="paginationarray"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true"
          showGridlines
        >
          <template #empty>
            <b style="text-align: center">No records found.</b>
          </template>
          <template #header>
            <div
              class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
            >
              <h5 class="m-0"><b> Event Master </b></h5>
              <!-- Total Records:{{totalRecords}} -->
              <div>
                <Button
                  icon="pi pi-plus"
                     
                  v-tooltip.bottom="'Add'"
                  @click="openNew"
                />
              
              
              </div>
            </div>
            <div style="text-align: right; font-weight: bold">
              <span>Total Event:</span>{{ totalRecords }}
            </div>
          </template>
          <Column header="Sr No" style="min-width: 5rem; text-align: center">
            <template #body="{ index }">
              <span v-if="page_no == 1">{{ +index + +1 }}</span>
              <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
            </template>
          </Column>
          <Column
            header="Status"
            style="min-width: 8rem; text-align: center"
            :field="columns[5]"
          >
            <template #body="{ data }">
              <span v-if="data.status == 'Active' || data.status == 'active'"
                ><badge :value="data.status" severity="success"></badge
              ></span>
              <span
                v-else-if="
                  data.status == 'InActive' || data.status == 'In Active'
                "
                ><badge :value="data.status" severity="warning"></badge
              ></span>
              <span
                v-else-if="data.status == 'Delete' || data.status == 'Deleted'"
                ><badge :value="data.status" severity="danger"></badge
              ></span>
              <span v-else>-</span>
            </template>
          </Column>
          
          <Column
            header="Event Name"
            :field="columns[1]"
            style="min-width: 5rem"
          >
            <template #body="{ data }">
              {{ data.name }}
            </template>
          </Column>
          <Column
            header="Description"
            :field="columns[2]"
            style="min-width: 10rem"
          >
            <template #body="{ data }">
              {{ data.description }}
            </template>
          </Column>
          <Column
            header="From Date"
            :field="columns[4]"
            style="min-width: 5rem"
          >
            <template #body="{ data }">
              {{ data.from_date }}
            </template>
          </Column>
          <Column header="To Date" :field="columns[4]" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.to_date }}
            </template>
          </Column>
          <Column header="State" :field="columns[4]" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.state }}
            </template>
          </Column>
          <Column header="City" :field="columns[4]" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.city }}
            </template>
          </Column>
          <Column header="Pincode" :field="columns[4]" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.pincode }}
            </template>
          </Column>
          <Column header="Action" headerStyle="min-width:10rem;">
            <template #body="slotProps">
              <Button
                icon="pi pi-pencil"
              class="p-button-rounded p-button-success p-button-sm mr-2"
                v-tooltip.bottom="'Edit'"
                @click="editProduct(slotProps.data)"
              />
              <Button
                v-if="slotProps.data.status != 'Deleted'"
                icon="pi pi-trash"
                v-tooltip.bottom="'Delete'"
               class="p-button-rounded p-button-danger p-button-sm mt-2"
                @click="confirmDeleteProduct(slotProps.data)"
              />
            </template>
          </Column>
        </DataTable>
        <Dialog
          header="Event"
          v-model:visible="productDialog"
          :breakpoints="{ '960px': '75vw' }"
          :style="{ width: '70vw' }"
          :modal="true"
        >
          <div class="col-12">
            <div class="card">
              <div class="p-fluid formgrid grid">
                <div class="field col-6 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <InputText
                      id="name"
                      type="text"
                      v-model.trim="product.name"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.name }"
                      onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || 
                      (event.charCode >= 97 && event.charCode <= 122) || 
                      event.charCode == 32"
                    />
                    <label for="name">Event Name</label>
                  </span>
                </div>
                <div class="field col-6 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <Dropdown
                      id="status"
                      v-model="selectstatus"
                      :options="dropdownItems"
                      :value="dropdownItems.value"
                      optionLabel="name"
                      :class="{ 'p-invalid': submitted && !selectstatus }"
                     
                      required="true"
                    ></Dropdown>
                    <label for="status">Status</label>
                  </span>
                </div>
                <div class="field col-6 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <Dropdown
                      id="status"
                      v-model="state_dropdownItem"
                      :options="state_dropdownItems"
                      :value="state_dropdownItems.value"
                      optionLabel="name"
                      :class="{ 'p-invalid': submitted && !state_dropdownItem }"
                      required="true"
                    ></Dropdown>
                    <label for="">State</label>
                  </span>
                </div>
                <div class="field col-6 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <InputText
                      id="city"
                      type="text"
                      v-model.trim="product.city"  
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.city }"
                      onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || 
                      (event.charCode >= 97 && event.charCode <= 122) || 
                      event.charCode == 32"
                    />
                    <label for="city">City</label>
                  </span>
                </div>
                <div class="field col-6 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <InputText
                      id="pincode"
                      type="text"
                      maxlength="6"
                      onkeypress="return event.charCode>=48 && event.charCode<=58"
                      v-model.trim="product.pincode" 
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.pincode }"
                    />
                    <label for="pincode">Pincode</label>
                  </span>
                </div>
                <div class="field col-6 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <InputText
                      id="time"
                      type="text"
                      v-model.trim="product.time" 
                        

                     onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || 
                                  (event.charCode >= 65 && event.charCode <= 90) || 
                                  (event.charCode >= 97 && event.charCode <= 122) || 
                                  event.charCode == 46 || event.charCode == 58 ||  event.charCode == 32"


                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.time }"
                    />
                    <label for="time">Time</label>
                  </span>
                </div>
                <div class="field col-6 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <!-- <Calendar
                      v-model="product.from_date"
                       
                      dateFormat="dd-mm-yy"
                      :showIcon="true"
                      :showTime="false"
                      hourFormat="12"
                    /> -->
                    <Calendar
      v-model="product.from_date" 
      dateFormat="dd-mm-yy"
      :showIcon="true"
      :showTime="false"
      :minDate="new Date()"
      hourFormat="12"
    />
                    <label for="from_date">From Date</label>
                  </span>
                </div>
                <div class="field col-6 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <Calendar
                      v-model="product.to_date"
                      dateFormat="dd-mm-yy"
                      :showIcon="true"
                      :showTime="false"
                        :minDate="new Date()"
                      hourFormat="12"
                    />
       
                    <label for="to_date">To Date</label>
                  </span>
                </div>
                <div class="field col-12 md:col-12" style="margin-top: 1%">
                  <span class="p-float-label">
                    <Textarea
                      id="description"
                      
                      type="text"
                      rows="4"
                      v-model.trim="product.description" 
                      required="true"
                        :showTime="false"
                        :minDate="new Date()"
                      autofocus
                      :class="{
                        'p-invalid': submitted && !product.description,
                      }"
                    />
                    <label for="description">Event Description</label>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <template #footer>
           
            <!-- <Button
              v-if="product._id"
              label="Update"
              @click="add_update_event"
              
              class="p-button-success mr"
              style="margin-right: 10%;"
            
             
            />
            
           

            <Button
              v-else
              label="Add"
              @click="add_update_event"
           
              class="p-button-success mr"
            
             
            /> -->

        
     

  <Button
              v-if="product._id"
              label="Update"
              @click="add_update_event"
              
              class="p-button-success "
              style="margin-right: 10%;"
            
             
            />
            
           

            <Button
              v-else
              label="Add"
              @click="add_update_event"
           
              class="p-button-success "
               style="margin-right: 3%;"
            
             
            />
                               
                                              <Button 
                              v-if="!product._id" 
                              class="p-button-danger "  

                              label="Reset" 
                              @click="refresh()" 
                            
                              style="margin-right: 10%;"
                            ></Button>
                                
                          
           
          </template>
        </Dialog>
        <!-- 
-----------------------------------------------------------------------------------------------------------   -->
        <Dialog
          v-model:visible="deleteProductDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem;color: red; "
             

            />
            <span v-if="product"
              >Are you sure you want to delete Event <b>{{ product.name }}</b
              >?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteevent"
            />
          </template>
        </Dialog>
        <Dialog
          v-model:visible="deleteProductsDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="product"
              >Are you sure you want to delete the selected products?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductsDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedProducts"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
//import JsonExcel from "vue-json-excel";
import BreadcrumbService from "../service/BreadcrumbService";
//import FormNewsMaster from "@/components/FormNewsMaster";

// import axios from "axios";
import apis from "@/apis";
import axios from "axios";
import { log } from "util";
export default {
  data() {
    return {
      state_dropdownItems: [
        { name: "Andhra Pradesh", value: "Andhra Pradesh" },
        { name: "Arunachal Pradesh", value: "Arunachal Pradesh" },
        { name: "Assam", value: "Assam" },
        { name: "Bihar", value: "Bihar" },
        { name: "Chhattisgarh", value: "Chhattisgarh" },
        { name: "Goa", value: "Goa" },
        { name: "Gujarat", value: "Gujarat" },
        { name: "Haryana", value: "Haryana" },
        { name: "Himachal Pradesh", value: "Himachal Pradesh" },
        { name: "Jharkhand", value: "Jharkhand" },
        { name: "Karnataka", value: "Karnataka" },
        { name: "Kerala", value: "Kerala" },
        { name: "Madhya Pradesh", value: "Madhya Pradesh" },
        { name: "Maharashtra", value: "Maharashtra" },
        { name: "Manipur", value: "Manipur" },
        { name: "Meghalaya", value: "Meghalaya" },
        { name: "Mizoram", value: "Mizoram" },
        { name: "Nagaland", value: "Nagaland" },
        { name: "Odisha", value: "Odisha" },
        { name: "Punjab", value: "Punjab" },
        { name: "Rajasthan", value: "Rajasthan" },
        { name: "Sikkim", value: "Sikkim" },
        { name: "Tamil Nadu", value: "Tamil Nadu" },
        { name: "Telangana", value: "Telangana" },
        { name: "Tripura", value: "Tripura" },
        { name: "Uttar Pradesh", value: "Uttar Pradesh" },
        { name: "Uttarakhand", value: "Uttarakhand" },
        { name: "West Bengal", value: "West Bengal" },
      ],
      state_dropdownItem: { name: "", value: "" },
      place_details: "",
      end_place_details: "",
      searchme: "",
      name: "",
      page_no: 1,
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      paginationarray:[5, 10, 25], 
      fullPage: true,
      file_attachment: "",
      icon_dropdown: [],
      event_name: "",
      event_from_date: "",
      event_to_date: "",
      event_status: null,
      event_city: "",
      dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      parent_dropdownItems: [],
      selectstatus: { name: "", value: "" },
      parent_selectstatus: { name: "", value: "" },
      pick_icon: { name: "", value: "" },
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      limit: 10,
      columns: [],
      pageno: 1,
      submitted: false,
      icons: null,
      totalRecords: 0,
      id: "",
      BreadcrumbService: null,
      breadcrumbHome: {},
      breadcrumbItems: [],
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    this.BreadcrumbService = new BreadcrumbService();
    let Breadcrum_data = this.BreadcrumbService.getBreadcrum(
      "Events",
      "/event_master"
    );
    //let Breadcrum_data = this.BreadcrumbService.menumaster();
    this.breadcrumbHome = Breadcrum_data.home;
    this.breadcrumbItems = Breadcrum_data.items;
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  methods: {
    refresh(){
      this.product.name="";
      this.selectstatus="";
      this.product.from_date="";
       this.product.time="";
    this.product.pincode="";
    this. product.city="";  
    this.state_dropdownItem="";
    this.product.description="";
     this.product.to_date="";
     this.product.from_date="";
     this.product.time="";
     this.product.pincode="";
     this.product.city=""; 
    
    },
    async search(count) {
      if (count == 2) {
        this.event_name = "";
        this.event_from_date = "";
        this.event_to_date = "";
        this.event_status = null;
        this.event_city = "";
      }
      await this.get_list();
      await this.get_count();
    },
    reset() {
      this.event_status = "";
      this.event_name = "";
      this.event_city = "";
      this.event_to_date = "";
      this.event_from_date = "";
     
       this.get_list();
      this.get_count();

   
    },
    editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;
      this.selectstatus = { name: "", value: "" };
      this.state_dropdownItem = { name: "", value: "" };
      if (this.product.status) {
        this.selectstatus.value = this.product.status;
        this.selectstatus.name = this.product.status;
      }
      if (this.product.state) {
        this.state_dropdownItem.value = this.product.state;
        this.state_dropdownItem.name = this.product.state;
      }
    },
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      }
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var data = {
        count: true,
        name: this.event_name,
        from_date: this.dateFormatYMD(this.event_from_date),
        to_date: this.dateFormatYMD(this.event_to_date),
        city: this.event_city,
        status: this.event_status == null ? "" : this.event_status.value,
      };
      this.loading = true;
      var promise = apis.eventList(data);
      promise.then((response) => {
        this.loading = false;
        this.totalRecords = response.data.data;
        this.paginationarray=[5, 10, 25];
        if(this.totalRecords > 25 )
        {
          this.paginationarray.push(this.totalRecords);
        }
      });
    },
    get_list: function () {
      var data = {
        limit: this.limit,
        page_no: this.page_no,
        count: false,
        name: this.event_name,
        from_date: this.dateFormatYMD(this.event_from_date),
        to_date: this.dateFormatYMD(this.event_to_date),
        city: this.event_city,
        status: this.event_status == null ? "" : this.event_status.value,
      };
      this.loading = true;
      var promise = apis.eventList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      console.log(data);
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
      this.selectstatus = null;
      this.state_dropdownItem = null;
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    dateFormatYMD(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return date + "-" + month + "-" + year;
          }
        }
      } else {
        return "";
      }
    },
    async add_update_event() {
      this.submitted = true;
      // if (!this.product.name) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter Event Name",
      //     life: 3000,
      //   });
      //   return false;
      // }
      const nameRegex = /^[a-zA-Z\s]+$/;
      if (!this. product.name || !nameRegex.test(this.product.name)) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Event Name can only contain letters and spaces.",
          life: 3000,
        });
        return false;
      }
      if (!this.selectstatus) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Status",
          life: 3000,
        });
        return false;
      }
      if (!this.state_dropdownItem) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select State Name",
          life: 3000,
        });
        return false;
      }
      if (!this.product.city) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter City",
          life: 3000,
        });
        return false;
      }
      if (!this.product.pincode) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Pincode",
          life: 3000,
        });
        return false;
      }
      if (!this.product.time) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Time",
          life: 3000,
        });
        return false;
      }
      // const timeRegex = /^[0-9.]+$/;
      // if ( !this.product.time ||!timeRegex.test(!this.product.time)) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "Error",
      //     detail: "Time can only contain numbers and dots.",
      //     life: 3000,
      //   });
      //   return false;
      // }
      if (!this.product.from_date) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select From date",
          life: 3000,
        });
        return false;
      }
      if (!this.product.to_date) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please select To Date",
          life: 3000,
        });
        return false;
      }
      if (!this.product.description) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter event Description",
          life: 3000,
        });
        return false;
      }
      this.product.status = this.selectstatus.value;
      this.product.state = this.state_dropdownItem.value;
      //edit
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          name: this.product.name,
          description: this.product.description,
          city: this.product.city,
          state: this.product.state,
          pincode: this.product.pincode,
          image_url: this.product.image_url,
          video_url: this.product.video_url,
          from_date: this.dateFormatYMD(this.product.from_date),
          to_date: this.dateFormatYMD(this.product.to_date),
          time: this.product.time,
          status: this.product.status,
          updated_by: localStorage.getItem("id"),
          //"client_id": this.client_id_search.value?this.client_id_search.value:localStorage.getItem("client_id"),
        };
        this.isLoadingModel = true;
        var promise = apis.editevent(data);
        promise
          .then((responseapi) => {
            this.$swal(responseapi.data.message);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
      //add-----------------------------------------------------------------------------------------------------------------
      else {
        var data1 = {
          name: this.product.name,
          description: this.product.description,
          city: this.product.city,
          state: this.product.state,
          pincode: this.product.pincode,
          image_url: this.product.image_url,
          video_url: this.product.video_url,
          from_date: this.dateFormatYMD(this.product.from_date),
          to_date: this.dateFormatYMD(this.product.to_date),
          time: this.product.time,
          status: this.product.status,
          created_by: localStorage.getItem("id"),
          //"client_id": this.client_id_search.value?this.client_id_search.value:localStorage.getItem("client_id"),
        };
        this.isLoadingModel = true;
        var promises = apis.addevent(data1);
        promises
          .then((response) => {
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal(response.data.message);
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteevent() {
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          updated_by: localStorage.getItem("id"),
        };
        this.isLoadingModel = true;
        var promise = apis.deleteevent(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            // this.hideDialog1();
            this.deleteProductDialog = false;
            this.$swal(responseapi.data.message);
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Role");
          }
        });
      }
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteProductsDialog = true;
    },
    deleteSelectedProducts() {
      this.products = this.products.filter(
        (val) => !this.selectedProducts.includes(val)
      );
      this.deleteProductsDialog = false;
      this.selectedProducts = null;
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Products Deleted",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {},
};
</script>
<style scoped lang="scss">
@import "../assets/demo/badges.scss";
@import "../assets/demo/documentation.scss";
.icons-list {
  i {
    color: var(--text-color-secondary);
  }
}
</style>
